import * as React from 'react';
import { useSelector } from 'react-redux';

import { DescriptionMobile } from './components';
import { realtorInfoApi } from '../../../api/realtorInfoApi';
import { selectCurrentRealtor } from '../../../selectors/selectCurrentRealtor';
import { ISpecialistCatalogListingSchema } from '../../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';

interface IProps {
  className?: string;
}

export const DescriptionMobileContainer: React.FunctionComponent<React.PropsWithChildren<IProps>> = ({ className }) => {
  const { cianUserId } = useSelector(selectCurrentRealtor) as ISpecialistCatalogListingSchema;
  const { data } = realtorInfoApi.endpoints.getRealtorInfo.useQueryState({
    cianUserId,
  });

  if (!data?.agent?.description) {
    return null;
  }

  return <DescriptionMobile text={data.agent.description} className={className} />;
};
